import { Color } from './color_models';
export const colors: Color[] = [
  {
    "name": "Abalone",
    "translucent": false,
    "marble": false,
    "limitedBending": false,
    "limitedWarranty": false,
    "scratches": false
  },
  {
    "name": "Antarctica",
    "translucent": false,
    "marble": false,
    "limitedBending": false,
    "limitedWarranty": false,
    "scratches": false
  },
  {
    "name": "Arctic Ice",
    "translucent": true,
    "marble": false,
    "limitedBending": false,
    "limitedWarranty": false,
    "scratches": false
  },
  {
    "name": "Arrowroot",
    "translucent": false,
    "marble": true,
    "limitedBending": true,
    "limitedWarranty": false,
    "scratches": false
  },
  {
    "name": "Artista Mist",
    "translucent": false,
    "marble": true,
    "limitedBending": false,
    "limitedWarranty": true,
    "scratches": false
  },
  {
    "name": "Artista Sage",
    "translucent": false,
    "marble": true,
    "limitedBending": false,
    "limitedWarranty": false,
    "scratches": false
  },
  {
    "name": "Ash Aggregate",
    "translucent": false,
    "marble": true,
    "limitedBending": true,
    "limitedWarranty": false,
    "scratches": false
  },
  {
    "name": "Ash Concrete",
    "translucent": false,
    "marble": true,
    "limitedBending": false,
    "limitedWarranty": true,
    "scratches": false
  },
  {
    "name": "Aspen",
    "translucent": false,
    "marble": false,
    "limitedBending": false,
    "limitedWarranty": false,
    "scratches": false
  },
  {
    "name": "Artista Beige",
    "translucent": false,
    "marble": true,
    "limitedBending": false,
    "limitedWarranty": true,
    "scratches": false
  },
  {
    "name": "Artista Canvas",
    "translucent": false,
    "marble": true,
    "limitedBending": false,
    "limitedWarranty": false,
    "scratches": false
  },
  {
    "name": "Artista Dust",
    "translucent": false,
    "marble": true,
    "limitedBending": false,
    "limitedWarranty": true,
    "scratches": false
  },
  {
    "name": "Artista Gray",
    "translucent": false,
    "marble": true,
    "limitedBending": false,
    "limitedWarranty": false,
    "scratches": false
  },
  {
    "name": "Aurora",
    "translucent": false,
    "marble": false,
    "limitedBending": false,
    "limitedWarranty": false,
    "scratches": false
  },
  {
    "name": "Beech Nuwood",
    "translucent": false,
    "marble": true,
    "limitedBending": true,
    "limitedWarranty": true,
    "scratches": false
  },
  {
    "name": "Bisque",
    "translucent": false,
    "marble": false,
    "limitedBending": false,
    "limitedWarranty": false,
    "scratches": false
  },
  {
    "name": "Bone",
    "translucent": false,
    "marble": false,
    "limitedBending": false,
    "limitedWarranty": false,
    "scratches": false
  },
  {
    "name": "Calacatta Greige",
    "translucent": false,
    "marble": true,
    "limitedBending": false,
    "limitedWarranty": false,
    "scratches": false
  },
  {
    "name": "Cameo White",
    "translucent": false,
    "marble": false,
    "limitedBending": false,
    "limitedWarranty": false,
    "scratches": false
  },
  {
    "name": "Carbon Aggregate",
    "translucent": false,
    "marble": true,
    "limitedBending": true,
    "limitedWarranty": false,
    "scratches": false
  },
  {
    "name": "Carbon Concrete",
    "translucent": false,
    "marble": true,
    "limitedBending": false,
    "limitedWarranty": true,
    "scratches": false
  },
  {
    "name": "Carrara Crema",
    "translucent": false,
    "marble": true,
    "limitedBending": false,
    "limitedWarranty": false,
    "scratches": false
  },
  {
    "name": "Carrara Lino",
    "translucent": false,
    "marble": true,
    "limitedBending": false,
    "limitedWarranty": false,
    "scratches": false
  },
  {
    "name": "Cirrus White",
    "translucent": false,
    "marble": true,
    "limitedBending": false,
    "limitedWarranty": false,
    "scratches": false
  },
  {
    "name": "Clam Shell",
    "translucent": false,
    "marble": true,
    "limitedBending": true,
    "limitedWarranty": false,
    "scratches": false
  },
  {
    "name": "Cosmos Prima",
    "translucent": false,
    "marble": true,
    "limitedBending": true,
    "limitedWarranty": false,
    "scratches": false
  },
  {
    "name": "Deep Anthracite",
    "translucent": false,
    "marble": false,
    "limitedBending": true,
    "limitedWarranty": true,
    "scratches": false
  },
  {
    "name": "Deep Black Quartz",
    "translucent": false,
    "marble": false,
    "limitedBending": true,
    "limitedWarranty": false,
    "scratches": true
  },
  {
    "name": "Deep Cloud",
    "translucent": false,
    "marble": false,
    "limitedBending": false,
    "limitedWarranty": true,
    "scratches": false
  },
  {
    "name": "Deep Espresso",
    "translucent": false,
    "marble": false,
    "limitedBending": true,
    "limitedWarranty": true,
    "scratches": false
  },
  {
    "name": "Deep Mink",
    "translucent": false,
    "marble": false,
    "limitedBending": true,
    "limitedWarranty": true,
    "scratches": false
  },
  {
    "name": "Deep Night Sky",
    "translucent": false,
    "marble": false,
    "limitedBending": true,
    "limitedWarranty": false,
    "scratches": true
  },
  {
    "name": "Deep Nocturne",
    "translucent": false,
    "marble": false,
    "limitedBending": true,
    "limitedWarranty": true,
    "scratches": false
  },
  {
    "name": "Deep Sable",
    "translucent": false,
    "marble": false,
    "limitedBending": true,
    "limitedWarranty": true,
    "scratches": false
  },
  {
    "name": "Deep Storm",
    "translucent": false,
    "marble": false,
    "limitedBending": true,
    "limitedWarranty": true,
    "scratches": false
  },
  {
    "name": "Deep Titanium",
    "translucent": false,
    "marble": false,
    "limitedBending": false,
    "limitedWarranty": true,
    "scratches": false
  },
  {
    "name": "Designer White",
    "translucent": false,
    "marble": false,
    "limitedBending": false,
    "limitedWarranty": false,
    "scratches": false
  },
  {
    "name": "Domino Terazzo",
    "translucent": false,
    "marble": false,
    "limitedBending": false,
    "limitedWarranty": false,
    "scratches": false
  },
  {
    "name": "Dove",
    "translucent": false,
    "marble": false,
    "limitedBending": false,
    "limitedWarranty": false,
    "scratches": false
  },
  {
    "name": "Dune Prima",
    "translucent": false,
    "marble": true,
    "limitedBending": true,
    "limitedWarranty": false,
    "scratches": false
  },
  {
    "name": "Elegant Gray",
    "translucent": false,
    "marble": false,
    "limitedBending": false,
    "limitedWarranty": false,
    "scratches": true
  },
  {
    "name": "Evening Prima",
    "translucent": false,
    "marble": true,
    "limitedBending": false,
    "limitedWarranty": true,
    "scratches": false
  },
  {
    "name": "Everest",
    "translucent": false,
    "marble": false,
    "limitedBending": false,
    "limitedWarranty": false,
    "scratches": false
  },
  {
    "name": "Excavage",
    "translucent": false,
    "marble": false,
    "limitedBending": false,
    "limitedWarranty": false,
    "scratches": false,
    "strength": true
  },
  {
    "name": "Glacier Ice",
    "translucent": true,
    "marble": false,
    "limitedBending": false,
    "limitedWarranty": true,
    "scratches": false
  },
  {
    "name": "Glacier White",
    "translucent": false,
    "marble": false,
    "limitedBending": false,
    "limitedWarranty": false,
    "scratches": false
  },
  {
    "name": "Gray Onyx",
    "translucent": true,
    "marble": true,
    "limitedBending": true,
    "limitedWarranty": false,
    "scratches": false
  },
  {
    "name": "Hazelnut",
    "translucent": false,
    "marble": true,
    "limitedBending": true,
    "limitedWarranty": false,
    "scratches": false
  },
  {
    "name": "Hot",
    "translucent": false,
    "marble": false,
    "limitedBending": false,
    "limitedWarranty": true,
    "scratches": false
  },
  {
    "name": "Juniper",
    "translucent": false,
    "marble": true,
    "limitedBending": true,
    "limitedWarranty": false,
    "scratches": false
  },
  {
    "name": "Laguna",
    "translucent": false,
    "marble": false,
    "limitedBending": false,
    "limitedWarranty": true,
    "scratches": false
  },
  {
    "name": "Laguna Terrazzo",
    "translucent": false,
    "marble": false,
    "limitedBending": false,
    "limitedWarranty": false,
    "scratches": false,
    "strength": true
  },
  {
    "name": "Lava Rock",
    "translucent": false,
    "marble": true,
    "limitedBending": true,
    "limitedWarranty": false,
    "scratches": false
  },
  {
    "name": "Light Ash",
    "translucent": false,
    "marble": false,
    "limitedBending": false,
    "limitedWarranty": false,
    "scratches": false
  },
  {
    "name": "Limestone Prima",
    "translucent": false,
    "marble": true,
    "limitedBending": false,
    "limitedWarranty": false,
    "scratches": false
  },
  {
    "name": "Linen",
    "translucent": false,
    "marble": false,
    "limitedBending": false,
    "limitedWarranty": false,
    "scratches": false
  },
  {
    "name": "Mahogany Nuwood",
    "translucent": false,
    "marble": true,
    "limitedBending": true,
    "limitedWarranty": true,
    "scratches": false
  },
  {
    "name": "Matterhorn",
    "translucent": false,
    "marble": false,
    "limitedBending": false,
    "limitedWarranty": false,
    "scratches": false
  },
  {
    "name": "Natural Gray",
    "translucent": false,
    "marble": true,
    "limitedBending": false,
    "limitedWarranty": true,
    "scratches": false
  },
  {
    "name": "Neutral Aggregate",
    "translucent": false,
    "marble": true,
    "limitedBending": false,
    "limitedWarranty": true,
    "scratches": false
  },
  {
    "name": "Neutral Concrete",
    "translucent": false,
    "marble": true,
    "limitedBending": false,
    "limitedWarranty": false,
    "scratches": false
  },
  {
    "name": "Nimbus Prima",
    "translucent": false,
    "marble": true,
    "limitedBending": true,
    "limitedWarranty": false,
    "scratches": false
  },
  {
    "name": "Pearl Gray",
    "translucent": false,
    "marble": false,
    "limitedBending": false,
    "limitedWarranty": false,
    "scratches": true
  },
  {
    "name": "Peppered Terrazzo",
    "translucent": false,
    "marble": false,
    "limitedBending": false,
    "limitedWarranty": false,
    "scratches": false,
    "strength": true
  },
  {
    "name": "Platinum",
    "translucent": false,
    "marble": false,
    "limitedBending": false,
    "limitedWarranty": false,
    "scratches": false
  },
  {
    "name": "Rain Cloud",
    "translucent": false,
    "marble": true,
    "limitedBending": true,
    "limitedWarranty": false,
    "scratches": false
  },
  {
    "name": "Rosemary",
    "translucent": false,
    "marble": true,
    "limitedBending": true,
    "limitedWarranty": false,
    "scratches": false
  },
  {
    "name": "Sagebrush",
    "translucent": false,
    "marble": true,
    "limitedBending": true,
    "limitedWarranty": false,
    "scratches": false
  },
  {
    "name": "Sahara",
    "translucent": false,
    "marble": false,
    "limitedBending": false,
    "limitedWarranty": false,
    "scratches": false
  },
  {
    "name": "Salt",
    "translucent": true,
    "marble": false,
    "limitedBending": false,
    "limitedWarranty": false,
    "scratches": false
  },
  {
    "name": "Sandalwood",
    "translucent": false,
    "marble": true,
    "limitedBending": true,
    "limitedWarranty": false,
    "scratches": false
  },
  {
    "name": "Sand Storm",
    "translucent": false,
    "marble": true,
    "limitedBending": false,
    "limitedWarranty": false,
    "scratches": false
  },
  {
    "name": "Savannah",
    "translucent": false,
    "marble": false,
    "limitedBending": false,
    "limitedWarranty": false,
    "scratches": false
  },
  {
    "name": "Sepia Linear",
    "translucent": true,
    "marble": true,
    "limitedBending": true,
    "limitedWarranty": false,
    "scratches": false
  },
  {
    "name": "Silt",
    "translucent": false,
    "marble": false,
    "limitedBending": false,
    "limitedWarranty": false,
    "scratches": false
  },
  {
    "name": "Silver Birch",
    "translucent": false,
    "marble": false,
    "limitedBending": false,
    "limitedWarranty": false,
    "scratches": false
  },
  {
    "name": "Silver Gray",
    "translucent": false,
    "marble": false,
    "limitedBending": false,
    "limitedWarranty": false,
    "scratches": true
  },
  {
    "name": "Silver Linear",
    "translucent": true,
    "marble": true,
    "limitedBending": false,
    "limitedWarranty": false,
    "scratches": false
  },
  {
    "name": "Smoke Drift Prima",
    "translucent": false,
    "marble": true,
    "limitedBending": true,
    "limitedWarranty": true,
    "scratches": false
  },
  {
    "name": "Sparkling Granita",
    "translucent": false,
    "marble": false,
    "limitedBending": false,
    "limitedWarranty": false,
    "scratches": false
  },
  {
    "name": "Sparkling White",
    "translucent": false,
    "marble": false,
    "limitedBending": false,
    "limitedWarranty": false,
    "scratches": false
  },
  {
    "name": "Stonecrest Smoke",
    "translucent": false,
    "marble": true,
    "limitedBending": false,
    "limitedWarranty": false,
    "scratches": false,
    "strength": false
  },
  {
    "name": "Stonique",
    "translucent": false,
    "marble": false,
    "limitedBending": false,
    "limitedWarranty": false,
    "scratches": false,
    "strength": true
  },
  {
    "name": "Vanilla",
    "translucent": false,
    "marble": false,
    "limitedBending": false,
    "limitedWarranty": false,
    "scratches": false
  },
  {
    "name": "Venaro White",
    "translucent": false,
    "marble": true,
    "limitedBending": true,
    "limitedWarranty": false,
    "scratches": false
  },
  {
    "name": "Verdant",
    "translucent": false,
    "marble": false,
    "limitedBending": false,
    "limitedWarranty": true,
    "scratches": false
  },
  {
    "name": "Weathered Aggregate",
    "translucent": false,
    "marble": true,
    "limitedBending": true,
    "limitedWarranty": false,
    "scratches": false
  },
  {
    "name": "Weathered Concrete",
    "translucent": false,
    "marble": true,
    "limitedBending": false,
    "limitedWarranty": true,
    "scratches": false
  },
  {
    "name": "White Jasmine",
    "translucent": false,
    "marble": true,
    "limitedBending": false,
    "limitedWarranty": false,
    "scratches": false
  },
  {
    "name": "White Onyx",
    "translucent": true,
    "marble": true,
    "limitedBending": true,
    "limitedWarranty": false,
    "scratches": false
  },
  {
    "name": "Willow",
    "translucent": false,
    "marble": true,
    "limitedBending": false,
    "limitedWarranty": false,
    "scratches": false
  },
  {
    "name": "Windswept Prima",
    "translucent": false,
    "marble": true,
    "limitedBending": true,
    "limitedWarranty": true,
    "scratches": false
  },
  {
    "name": "Witch Hazel",
    "translucent": false,
    "marble": true,
    "limitedBending": true,
    "limitedWarranty": false,
    "scratches": false
  }
];
